import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { ItemInfo } from '../vo/item-info.model';
import { ItemEditableInfo } from '../vo/item-editable-info.model';

// レスポンス構造
export type GetCycleItemInfoResponse = {
  CycleItemInfoList: CycleItemInfoList;
  TagSelectionInfo: { ClassCode: string; TagSelectionList: { TagId: string; TagName: string }[] }[]
}

export type CycleItemInfoList = {
  MediumName: string;
  MediumType: string;
  ClassCode: string;
  ClassName: string;
  MiddleClassName: string;
  SmallClassName: string;
  CategoryTagId: string;
  CategoryTagName: string;
  TagInfoList: { TagId: string; TagName: string }[];
  GoodsName: string;
  StandardName: string;
  SupplyTaxWithoutStd: number,
  CostPriceStandard: number,
  GprStd: string,
  SupplyTaxWithoutSpc1: number,
  CostPriceSpecial1: number,
  GprSpc1: string,
  SupplyTaxWithoutSpc2: number,
  CostPriceSpecial2: number,
  GprSpc2: string,
  AllCoop: string;
  EnableSet: string;
  Pcode: string;
  RelationPcode: string;
  CoopCode: string;
  ItemCode: string;
  JanCode: string;
  LargeClassName: string;
  PayeeClient: string;
  OrderClient: string;
  ApplyTermStart: string;
  ApplyTermEnd: string;
  GoodsMemo: string;
  CatalogInfoList: {
    OrderCode: string;
    CatalogId: string;
    Status: string;
    PricePattern: string;
    FeatureCode: string;
    SelectedOthers: string;
    KomaPromotion: string;
    DispValue1: number;
    DispValue2: number;
    DelivStartDate: string;
    CatalogMemo: string;
  }[];
  NumSum: number;
  PriceSum: number;
}[];

/**
 * サイクル設定商品情報取得サービス
 * @export GetCycleItemInfoService
 * @class GetCycleItemInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCycleItemInfoService extends PlessJsonResponderSub<GetCycleItemInfoResponse> {
  model: KYMW1200Model;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCycleItemInfoService
   */
  private getBody(): PlessRequest {
    const param = {
      MediumType: this.model.mediumType,
      BuyerCodes: this.model.getRequestBuyerCodes(),
      CoopCode: this.model.coopCode,
      DispDiv: this.model.switchType,
      StartOrderCode: this.model.orderCodeFrom,
      EndOrderCode: this.model.orderCodeTo,
      SupplierCode: this.model.isSupplier ? this.model.userSupplierCode : null,
      PastCycle: this.model.pastCycle,
    };
    if (!param.SupplierCode) delete param.SupplierCode;

    return new PlessRequest({ parameter: param });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof GetCycleItemInfoService
   */
  execute(
    model: KYMW1200Model,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.model.itemList = [];
    this.model.itemListOrigin = [];
    this.model.otherMediums = [];
    this.model.clearSearchedCondition();
    this.succeed = s;
    this.fail = f;
    this.send('getCycleItemInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCycleItemInfoService
   */
  success(data: GetCycleItemInfoResponse) {
    this.model.itemList = data.CycleItemInfoList.map(_ => new ItemInfo(_, data.TagSelectionInfo));
    this.model.itemListOrigin = data.CycleItemInfoList.map(_ => new ItemEditableInfo(_));
    this.model.storeSearchedCondition();
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW1200Model): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
